import { RootState } from "../../../../store/types";
import { connect } from "react-redux";
import VolumeTargetDisplay from "./VolumeTargetDisplay";

const mapStateToProps = (state: RootState) => ({
    totalTargetVolume: state.volumesAndWip.targetAndWIPVolume?.totalTargetVolume
});

export default connect(mapStateToProps)(VolumeTargetDisplay);